<clx-popover [(visible)]="isVisible" height="auto" i18n-title="@@mass-upgrade.config.title" title="Configure upgrade">
    <messages name="uprgadeMessage" #messageBox></messages>
    <clx-form
        has="top-labels"
        [create]="send.bind(this)"
        test-id="mass-upgrade.start-upgrade-window"
        [disableChangeChecking]="true"
        messageTarget="uprgadeMessage"
        editMode="create"
    >
        <clx-row>
            <clx-label i18n="@@mass-upgrade.config.label.download-timeout.name">Name</clx-label>
            <clx-input name="name" test-id="mass-upgrade.start-upgrade-window.name.input">
                <clx-validation type="required"></clx-validation>
            </clx-input>
        </clx-row>
        <clx-row>
            <clx-label i18n="@@mass-upgrade.config.label.schedule">Start</clx-label>
            <clx-datetime name="startTime" [(ngModel)]="start" [min]="now" type="datetime" test-id="mass-upgrade.start-upgrade-window.startdate.input">
                <clx-validation type="datetime"></clx-validation>
                <clx-validation type="required"></clx-validation>
            </clx-datetime>
        </clx-row>
        <clx-row>
            <clx-label i18n="@@mass-upgrade.config.label.schedule.end">End</clx-label>
            <clx-datetime name="endTime" [(ngModel)]="end" [min]="now" type="datetime" test-id="mass-upgrade.start-upgrade-window.startdate.input.end">
                <clx-validation type="datetime"></clx-validation>
                <clx-validation type="required"></clx-validation>
            </clx-datetime>
        </clx-row>
        <clx-row>
            <clx-label i18n="@@mass-upgrade.config.label.use-plant-timezone.label">Use plant's time zone</clx-label>
            <clx-item has="checkbox-label-layout">
                <clx-checkbox name="usePlantTimeZone" test-id="@mass-upgrade.config.use-plant-timezone"></clx-checkbox>
                <span i18n="@@@mass-upgrade.config.use-plant-timezone.text">When checked, the plants will be updated in the timespan of their respective local time zone. Otherwise, your local time will be applied to all plants.</span>
            </clx-item>
        </clx-row>
        <clx-row>
            <clx-label i18n="@@mass-upgrade.config.label.download-timeout">Download timeout(minutes)</clx-label>
            <clx-input name="FileDownloadTimeout" type="number" [value]="60" test-id="mass-upgrade.start-upgrade-window.file-download-timeout.input"></clx-input>
        </clx-row>
        <clx-row>
            <clx-label i18n="@@mass-upgrade.config.label.application-shutdown">Application shutdown timeout(minutes)</clx-label>
            <clx-input name="ApplicationShutdownTimeout" type="number" [value]="30" test-id="mass-upgrade.start-upgrade-window.application-shutdown-timeout.input"></clx-input>
        </clx-row>
        <clx-row>
            <clx-label i18n="@@mass-upgrade.config.label.retries">Retries</clx-label>
            <clx-input name="RetryCount" type="number" [value]="3" test-id="mass-upgrade.start-upgrade-window.retry-count.input"></clx-input>
        </clx-row>
        <clx-row>
            <clx-label i18n="@@mass-upgrade.config.label.notify">Notify</clx-label>
            <clx-input name="NotificationRecipients" [value]="notify" test-id="mass-upgrade.start-upgrade-window.notify.input"></clx-input>
        </clx-row>
        <clx-row>
            <clx-label  i18n="@@upgrade.config.label.mapping">Mapping File</clx-label>
            <clx-select name="mappingFileName" #parameterSelect test-id="mass-upgrade.start-upgrade-window.parameter.input">
                <clx-value [value]="null" i18n="@@mass-upgrade.start-upgrade-window.mappig-file-name.option.use-applicationset">use applicationset</clx-value>
                <clx-value value="UsePlantFile" i18n="@@mass-upgrade.start-upgrade-window.mappig-file-name.option.use-plantfile">use plantfile</clx-value>
            </clx-select>
        </clx-row>
        <clx-row>
            <clx-label i18n="@@mass-upgrade.config.label.parameter">Parameter</clx-label>
            <clx-select name="parameterfilename" #parameterSelect test-id="mass-upgrade.start-upgrade-window.parameter.input">
                <clx-value value="UseCurrent"  i18n="@@mass-upgrade.start-upgrade-window.parameter.option.use-current">use current</clx-value>
                <clx-value value="UseApplicationSet"  i18n="@@mass-upgrade.start-upgrade-window.parameter.option.use-applicationset">use applicationset</clx-value>
            </clx-select>
        </clx-row>
        <clx-row>
            <clx-label i18n="@@mass-upgrade.config.label.bacnet">BACnet</clx-label>
            <clx-select name="bacnetfilename" #bacnetSelect test-id="mass-upgrade.start-upgrade-window.bacnet-parameter.input">
                <clx-value value="UseCurrent"  i18n="@@mass-upgrade.start-upgrade-window.bacnet-parameter.option.use-current">use current</clx-value>
                <clx-value value="UseApplicationSet" i18n="@@mass-upgrade.start-upgrade-window.bacnet-parameter.option.use-applicationset">use applicationset</clx-value>
            </clx-select>
        </clx-row>
        <clx-row>
            <clx-label i18n="@@mass-upgrade.config.label.comment">Comment</clx-label>
            <clx-textarea name="Comment" test-id="mass-upgrade.start-upgrade-window.comment.input"></clx-textarea>
        </clx-row>
        <clx-row type="buttons">
            <clx-button
                type="save"
                #savebutton
                i18n="@@mass-upgrade.config.button.ok"
                test-id="mass-upgrade.start-upgrade-window.save.button"
            >Ok</clx-button>
            <clx-button
                (click)="close()"
                i18n="@@mass-upgrade.config.button.cancel"
                test-id="mass-upgrade.start-upgrade-window.cancel.button"
            >Cancel</clx-button>
        </clx-row>
    </clx-form>
</clx-popover>